<template>
  <PageHeaderLayout>
    <div class="main-page-content">
      <el-row :gutter="20">
        <el-col :span="6">
          <div class="left-right">
            <div class="column-list">栏目列表</div>
            <div class="tree-wrapper">
              <el-checkbox v-model="checkAll" @change="handleCheckAllChange" class="check-all">{{ this.checkTitle }}</el-checkbox>
              <el-checkbox v-model="expendAll" @change="handleExpendAllChange" class="check-all">{{ this.expendTitle }}</el-checkbox>
              <el-tree
                ref="vuetree"
                :expand-on-click-node="false"
                :data="data"
                :props="defaultProps"
                show-checkbox
                node-key="id"
                @check-change="handleCheckChange"
                @node-click="handleNodeClick">
              </el-tree>
            </div>
          </div>
        </el-col>
        <el-col :span="18">
          <div class="right-wrapper">
            <div class="column-list">当前级别{{ this.currentTitle }}</div>
            <el-tabs v-model="activeName" type="card" @tab-click="handleClick" class="column-list">
              <el-tab-pane v-for="(item, index) in this.tabsList" :label="item.label" :key="index" :name="item.name" class="tab-item">
              </el-tab-pane>
            </el-tabs>
            <el-row>
              <el-form :inline="true" :model="searchCondition" class="demo-form-inline">
                <el-form-item label="名称">
                  <el-input v-model="searchCondition.channel_name" placeholder="输入任务名称" clearable></el-input>
                </el-form-item>
                <el-form-item label="日期">
                  <DatePicker @dataSearch="dataSearch"/>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="searchButton">查询</el-button>
                </el-form-item>
              </el-form>
            </el-row>
            <ApeTable class="right-table" ref="apeTable" :data="dataList" :columns="columns" :loading="loadingStaus" @switchPaging="switchPaging" highlight-current-row >
            </ApeTable>
          </div>
        </el-col>
      </el-row>
    </div>
  </PageHeaderLayout>
</template>
<script>
import PageHeaderLayout from '@/layouts/PageHeaderLayout'
import ApeTable from '@/components/ApeTable'
import DatePicker from '@/components/DatePicker.vue'
export default {
  components: {
    PageHeaderLayout,
    ApeTable,
    DatePicker
  },
  data() {
    return {
      tabsList: [
        {
          label: '待上传',
          name: 'waiteUpload'
        },
        {
          label: '已上传',
          name: 'upload'
        },
        {
          label: '待审核',
          name: 'notChecked'
        },
        {
          label: '已审核',
          name: 'checked'
        },
      ],
      activeName: 'waiteUpload',
      data: [{
        id: 1,
        label: '一级 1',
        children: [{
          id: 4,
          label: '二级 1-1',
          children: [{
            id: 9,
            label: '三级 1-1-1'
          }, {
            id: 10,
            label: '三级 1-1-2'
          }]
        }]
      }, {
        id: 2,
        label: '一级 2',
        children: [{
          id: 5,
          label: '二级 2-1'
        }, {
          id: 6,
          label: '二级 2-2'
        }]
      }, {
        id: 3,
        label: '一级 3',
        children: [{
          id: 7,
          label: '二级 3-1'
        }, {
          id: 8,
          label: '二级 3-2',
          children: [{
            id: 11,
            label: '三级 3-2-1'
          }, {
            id: 12,
            label: '三级 3-2-2'
          }, {
            id: 13,
            label: '三级 3-2-3'
          }]
        }]
      }],
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      currentTitle : '',//控制右边显示的标题
      dataList: [],//表格数据
      columns: [
        {
          title: '任务名称',
          value: 'name',
          header_align: 'center',
          align: 'center',
          width: 200
        },
        {
          title: '总金额',
          value: [
            {label:'总金额：', value:'total_amount'},
            {label:'人员数：', value:'total_num'},
          ],
          header_align: 'center',
          width: 200
        },
        {
          title: '提交时间',
          value: 'created_at',
          header_align: 'center',
          align: 'center',
        },
        {
          title: '结算状态',
          value: 'alias_status',
          header_align: 'center',
          align: 'center',
        },
        {
          title: '审核状态',
          value: 'alias_bill_status',
          width: 180,
          header_align: 'center',
          align: 'center',
        },
      ],
      checkTitle: '选中全部',
      expendTitle: '展开全部',
      loadingStaus: false,
      checkAll: false,//控制是否全部选中
      expendAll: false,//控制checkbox状态是否展开全部
      checkedList: [],//默认勾选的节点的 key 的数组
      searchCondition:{// 搜索条件
      },
    };
  },
  created() {
    this.init()
  },
  methods: {
    // 搜索
    searchButton() {
      this.init('search')
    },
    //获取选中日期的值
    dataSearch(value) {
      this.searchCondition.time_value = value
    },
     //点击tab切换
    handleClick(tab) {
      // if(tab.name == 'waiteUpload') {
      //   this.dataList = this.waiteUploadList
      // }else if(tab.name == 'upload') {
      //   this.dataList = this.uploadList
      // }else if(tab.name == 'notChecked') {
      //   this.dataList = this.notCheckedList
      // }else {
      //   this.dataList = this.checkedList
      // }
      console.log(tab.name,"llllllokoko");
    },
    handleCheckAllChange() {//全选、取消全选
      if(this.checkAll == true) {
        //全选
        this.$refs.vuetree.setCheckedNodes(this.data);
        this.checkTitle = '取消选中全部'
      }else {
        //取消选中
        this.$refs.vuetree.setCheckedKeys([]);
        this.checkTitle = '选中全部'
      }
    },
    handleExpendAllChange() {//全展开、取消全展开
      if(this.expendAll == true) {
        //全部展开
        for(let i=0;i<this.$refs.vuetree.store._getAllNodes().length;i++) {
          this.$refs.vuetree.store._getAllNodes()[i].expanded = true
          this.expendTitle = '取消展开全部'
        }
      }else {
        //取消全部展开
        for(let i=0;i<this.$refs.vuetree.store._getAllNodes().length;i++) {
          this.$refs.vuetree.store._getAllNodes()[i].expanded = false
          this.expendTitle = '展开全部'
        }
      }
    },
    handleCheckChange(data, checked, indeterminate) {
      console.log(data, checked, indeterminate);
    },
    handleNodeClick(data, node) {
      let current = node;
      let path = '';
      if(current.level >= 3) {
        while(current.parent) {
          path = current.data.label + (current.level < 3 ? ' 》 ': '') + path;
          current = current.parent;
        }
      }
      this.currentTitle = path;
    },
     // 初始化列表
    async init(type) {
      console.log(type)
      // this.loadingStaus=true
      // let pagingInfo = this.$refs['apeTable'].getPagingInfo(type)
      // let searchCondition = this.handleSearchCondition()
      // Object.assign(searchCondition,pagingInfo)
      let {list}= await this.$api.getAdminBillList()
      this.dataList = []
      this.$nextTick(() => {
        this.dataList=list
      })
      this.loadingStaus=false
    },
     // 切换页码操作
    async switchPaging() {
      this.init()
    },
  }
}
</script>
<style lang="stylus" scoped >
  /deep/.el-table tr
    min-height: 20px
  .right-table
    margin-top: -40px
    padding: 0 20px
    height: calc(100vh - 300px)
  .tree-wrapper
    // margin-top:20px
    box-shadow: 0 1px 12px 0 rgba(0, 0, 0, 0.1)
    padding: 20px
    padding-bottom: 0
    height: calc(100vh - 70px)
  .column-list
    width: 100%
    height: 50px
    line-height: 50px
    background: #e3eaf1
    color: #303133
    font-weight: bold
    // font-size: 18px
    text-align: center
    box-shadow: 0 1px 12px 0 rgba(0, 0, 0, 0.1)
    border-top-left-radius: 5px
    border-top-right-radius: 5px
  .left-right,
  .right-wrapper
    box-shadow: 0 1px 12px 0 rgba(0, 0, 0, 0.1)
    height: 100vh
    background: #fff
  .card
    background: #D0D0D0
  .check-all
    padding-bottom: 10px
  .demo-form-inline
    padding-top: 10px
    margin-left: 20px
    overflow: hidden
</style>